import React,{useEffect} from "react";
import { useFormik } from "formik";
import { Button, Col, Form, Row } from "react-bootstrap";
import * as yup from "yup";

import { AddNewCampaignAction,  UpdateEditTagDataAction, } from "../../../Redux/Actions/TagGeneratorAction";
import { IReduxState } from "../../../utils/types";
import { useSelector } from "react-redux";
import { useState } from "react";

interface Props {
    editTagData: any, 
    setActiveScreen:any,
    dispatch:any,
    refreshList:any,
    setEditTagData:any
}
const AddEditTagForm = ({editTagData , setActiveScreen,dispatch,refreshList,setEditTagData}: Props)=>{
    const AuthState = useSelector((state: IReduxState) => state.Auth);
    const tagGeneratorState = useSelector((state: IReduxState) => state.TagGenerator );
    const [dspSelection, setDSPSelection] = useState('BeesWax');
    const [typeSelection, setTypeSelection] = useState('');
    const [ytvSelection, setYTVSelection] = useState('');
    const [exchangeSelection, setExchangeSelection] = useState('General');
    const [addOnsSelection, setAddOnsSelection] = useState('No');
    const [ipV6Selection,setIpV6Selection]=useState(false);
    const [infiniteFifoSelection, setInfiniteFifoSelection] = useState(AuthState?.cc_infinite_fifo ? "Yes" : "No");
    const [specialSelection, setSpecialSelection] = useState(infiniteFifoSelection==="Yes"?false:true);

    
    const initialValues = {
        dsp: "BeesWax",
        type: "Image",
        //env: "MobileWeb",
        YouTubeVideo: "No",
        name: "",
        landingPage: "",
        imageUrl: "",
        videoUrl: "",
        special: infiniteFifoSelection==="Yes"?false:true,
        er_id: "",
        url: "",
        exchange: "General",
        addOns: "No",
        infinite_fifo: AuthState?.cc_infinite_fifo ? "Yes" : "No",
        infinite_fifo_id: "",
        ipV6:false
    };

    console.log(tagGeneratorState?.edit_data[0])
    const formik: any = useFormik({
        initialValues: editTagData && tagGeneratorState?.edit_data[0]
        ? {
            dsp: tagGeneratorState?.edit_data[0].dsp,
            type: tagGeneratorState?.edit_data[0].type,
            //env: tagGeneratorState?.edit_data[0].env,
            YouTubeVideo:  tagGeneratorState?.edit_data[0].YouTubeVideo,
            name: tagGeneratorState?.edit_data[0].name,
            landingPage: tagGeneratorState?.edit_data[0].landingPage,
            imageUrl:  tagGeneratorState?.edit_data[0].imageUrl,
            videoUrl: tagGeneratorState?.edit_data[0].videoUrl,
            special: tagGeneratorState?.edit_data[0].special, 
            er_id: tagGeneratorState?.edit_data[0].er_id,
            url: "",
            exchange: tagGeneratorState?.edit_data[0].exchange,
            addOns: tagGeneratorState?.edit_data[0].addOns,
            infinite_fifo: tagGeneratorState?.edit_data[0].infinite_fifo,
            infinite_fifo_id: tagGeneratorState?.edit_data[0].infinite_fifo_id,
            ipV6:tagGeneratorState?.edit_data[0].ipV6

            
        }: initialValues,
    
    validationSchema:  yup.object().shape({
        name: yup.string().required(),
        landingPage: yup
          .string()
          .matches(
            /https?:\/\/(?:w{1,3}\.)?[^\s.]+(?:\.[a-z]+)(?::\d+)?(?![^<](?:<\/\w+>|\/?>))/,
            "Enter correct url!"
          )
          .required(),
        imageUrl: yup
          .string()
          .matches(
            /https?:\/\/(?:w{1,3}\.)?[^\s.]+(?:\.[a-z]+)(?::\d+)?(?![^<](?:<\/\w+>|\/?>))/,
            "Enter correct url!"
          )
          .when("type", {
            is: "Image",
            then: yup.string().required("*"),
          }),
        videoUrl: yup
          .string()
          .matches(
            /https?:\/\/(?:w{1,3}\.)?[^\s.]+(?:\.[a-z]+)(?::\d+)?(?![^<](?:<\/\w+>|\/?>))/,
            "Enter correct url!"
          )
          .when("type", {
            is: "Video",
            then: yup.string().required("*"),
          }),
        infinite_fifo_id: yup.string()
          .when("infinite_fifo", {
            is: "Yes",
            then: yup.string().required("*"),
          }),
    }),
    

    onSubmit: async (values:any) =>{
        const newCampagin: any = {
            dsp: values.dsp,
            type: values.type,
            //env: tagGeneratorState?.edit_data[0].env,
            YouTubeVideo:  values.YouTubeVideo,
            name: values.name,
            landingPage: values.landingPage,
            imageUrl:  values.imageUrl,
            videoUrl: values.videoUrl,
            special: values.special, 
            er_id: values.er_id,
            url: "",
            exchange: values.exchange, 
            addOns: values.addOns,
            infinite_fifo: values.infinite_fifo,
            infinite_fifo_id: values.infinite_fifo_id,
            ipV6:values.ipV6
        }
        if (editTagData) {
            await dispatch(
              UpdateEditTagDataAction(values, tagGeneratorState?.edit_data[0]._id)
            );
          } else { 
            await dispatch(AddNewCampaignAction(values)); 
          }
          await refreshList();
    }
})

const onDSPChange = (e: any) => {
    if (e.target.value === "BeesWax") {
        formik.setFieldValue("dsp", "BeesWax");
        // formik.setFieldValue("exchange", "All")
    } else if (e.target.value === "MyDSP") {
        formik.setFieldValue("dsp", "MyDSP");
    } else if (e.target.value === "ESKIMI") {
        formik.setFieldValue("dsp", "ESKIMI");
        // formik.setFieldValue("exchange", "All")
    }

    formik.setFieldValue("dsp", e.target.value);
    setDSPSelection(e.target.value);
}

const onTypeChange = (e: any) => {
    if (e.target.value === "Video") {
        formik.setFieldValue("type", "Video");
    } else if (e.target.value === "Image") {
        formik.setFieldValue("type", "Image");
    }

    formik.setFieldValue("type", e.target.value);
    setTypeSelection(e.target.value);
}

const onYTVChange = (e: any) => {
    if (e.target.value === "No") {
        formik.setFieldValue("YouTubeVideo", "No");
    } else if (e.target.value === "Yes") {
        formik.setFieldValue("YouTubeVideo", "Yes");
    }

    formik.setFieldValue("YouTubeVideo", e.target.value);
    setYTVSelection(e.target.value);
}

const onSpecialChange = (e: any) => {
    if (e.target.value === false) {
        formik.setFieldValue("special", false);
    } else if (e.target.value === true) {
        formik.setFieldValue("special", true);
    }

    formik.setFieldValue("special", e.target.value);
    setSpecialSelection(e.target.value);
}

const onIpV6Change = (e: any) => {
    if (e.target.value === false) {
        formik.setFieldValue("ipV6", false);
    } else if (e.target.value === true) {
        formik.setFieldValue("ipV6", true);
    }

    formik.setFieldValue("ipV6", e.target.value);
    setIpV6Selection(e.target.value);
}

const onExchangeChange = (e: any) => {
    formik.setFieldValue("exchange", e);
    setExchangeSelection(e);
}

const onAddOnsChange = (e: any) => {
    formik.setFieldValue("addOns", e);
    setAddOnsSelection(e);
}

const onInfiniteFifoChange = (e: any) => {
        formik.setFieldValue("infinite_fifo", e.target.value);
        if (e.target.value === 'Yes') {
            formik.setFieldValue("special", false);
        }
        setInfiniteFifoSelection(e.target.value);
}

    useEffect(() => { 
        return () => {
          setActiveScreen(1);
          setEditTagData(false); 
        }
    }, [setActiveScreen,setEditTagData])

    const dspList = ["BeesWax", "MyDSP", "ESKIMI"]; 

    useEffect(() => {
        if(formik.values.dsp === 'MyDSP'){
            onExchangeChange(exchangeSelection)
            if(formik.values.exchange === "GoogleAdx"){
                formik.setFieldValue("special", false)
                formik.setFieldValue("infinite_fifo", "No")
                formik.setFieldValue("addOns", "No")
                formik.setFieldValue("ipV6",false)
            } else {
                // if(formik.values.exchange === "Yandex RU"){
                //     // formik.setFieldValue("special", true)
                //     // formik.setFieldValue("infinite_fifo", "No")
                // }
                // onAddOnsChange(addOnsSelection)
                // onSpecialChange({target:{value:specialSelection}})
            }
        } else if (formik.values.dsp === "ESKIMI"){
            onSpecialChange({target:{value:specialSelection}})
            formik.setFieldValue("exchange", "General")
            formik.setFieldValue("addOns", "No")
        } else if (formik.values.dsp === "BeesWax"){
            onSpecialChange({target:{value:specialSelection}})
            onIpV6Change({target:{value:ipV6Selection}})
            formik.setFieldValue("exchange", "General")
            onAddOnsChange(addOnsSelection)
        }
    }, [formik.values.dsp])

    useEffect(() => {
        if(formik.values.exchange === "GoogleAdx"){
            if(formik.values.dsp === 'MyDSP'){
                onExchangeChange(exchangeSelection)
                formik.setFieldValue("addOns", "No")
                formik.setFieldValue("special", false)
            } else {
                onAddOnsChange(addOnsSelection)
                onSpecialChange({target:{value:specialSelection}})
            }
        } else if (formik.values.exchange === "Yandex RU") {
            if(formik.values.dsp === 'MyDSP'){
                onExchangeChange(exchangeSelection)
                formik.setFieldValue("addOns", "No")
                // formik.setFieldValue("special", true)
                // formik.setFieldValue("infinite_fifo", "No")

            } else {
                onSpecialChange({target:{value:specialSelection}})
                onInfiniteFifoChange(infiniteFifoSelection);
            }
        }
    },[formik.values.exchange])
    
    return (
        <>
            {/* {({ handleSubmit, handleChange, values, touched, errors,resetForm }) => ( */}
                {/* <Form noValidate onSubmit={handleSubmit}> */}
                    <Row>
                        <Row>
                            <Col md={6}> 
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label column md={2}>DSP</Form.Label>
                                    <Col md={10}>
                                        <Form.Select
                                            name="dsp"
                                            defaultValue={formik.initialValues.dsp}
                                            //value={dspSelection}
                                            className="fsz-875rem"
                                            onChange={
                                                async (e) => {
                                                    await onDSPChange(e)
                                                    formik.validateForm();
                                                }}
                                        >
                                            
                                            {dspList.map((item: string) => (
                                            <option key={item} value={item}>
                                                {item}
                                            </option>
                                            ))}
                                        </Form.Select> 
                                    </Col>
                                </Form.Group>

                                <Form.Group as={Row} className="mb-3" controlId="validationFormikname">
                                    <Form.Label column md={2}>Campaign Name <span style={{ color: "#dc3545", fontFamily: "Silka", fontSize: 12, }}>*</span></Form.Label>
                                    <Col md={10}>
                                        <Form.Control
                                            type="text"
                                            name="name"
                                            value={formik.values.name}
                                            onChange={formik.handleChange}
                                            isInvalid={!!formik.errors.name}
                                        />
                                        {/* <Form.Control.Feedback type="invalid"> {errors.name} </Form.Control.Feedback> */}
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="validationFormikUrl">
                                    <Form.Label column md={2}>Image URL<span style={{ color: "#dc3545", fontFamily: "Silka", fontSize: 12, }}>*</span></Form.Label>
                                    <Col md={10}>
                                        <Form.Control
                                            type="text"
                                            name={formik.values.type === "Image"? "imageUrl": "videoUrl"}
                                            defaultValue={(formik.values.type === "Image"? formik.values.imageUrl: formik.values.videoUrl)}
                                            onChange={(e) => {
                                                if (formik.values.type === "Image") {
                                                    formik.setValues({
                                                        ...formik.values,
                                                        videoUrl: ""
                                                    });
                                                } else {
                                                    formik.setValues({
                                                        ...formik.values,
                                                        imageUrl: ""
                                                    });
                                                }
                                                formik.handleChange(e);
                                            }}
                                            isInvalid={formik.values.type === "Image"? !!formik.errors.imageUrl: !!formik.errors.videoUrl}
                                        />
                                        {/* <Form.Control.Feedback type="invalid"> {values.type === "Image"? errors.imageUrl: errors.videoUrl} </Form.Control.Feedback> */}
                                    </Col>
                                </Form.Group>

                                <Form.Group as={Row} className="mb-3" controlId="validationFormikSpecial">
                                    <Form.Label column md={2}>Special</Form.Label>
                                    <Col md={10}>
                                        <Form.Select
                                            name="special" 
                                            className="fsz-875rem"
                                            value={formik.values.special}
                                            disabled = {formik.values.exchange === "GoogleAdx" || formik.values.exchange === "Yandex RU"|| formik.values.infinite_fifo==="Yes"}
                                            //defaultValue={initialValues.special==true?'true':'false'}
                                            //defaultValue={initialValues.special==true?'true':'false'}
                                            onChange={
                                                async (e) => {
                                                    await onSpecialChange(e)
                                                    formik.validateForm();
                                                }}
                                        >
                                            {[{ value: true, name: "Yes" }, { value: false, name: "No"}, ].map((item: any) => (
                                                <option key={item.name} value={item.value}>
                                                    {formik.values.exchange === "GoogleAdx"? "No" : (formik.values.exchange === "Yandex RU" && formik.values.infinite_fifo==="No")? 'Yes': item.name}
                                                </option>
                                            ))}
                                        </Form.Select> 
                                        {/* <Form.Control.Feedback type="invalid"> {errors.landingPage} </Form.Control.Feedback> */}
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="validationFormikExchange">
                                    <Form.Label column md={2}>Exchange<span style={{ color: "#dc3545", fontFamily: "Silka", fontSize: 12, }}>*</span></Form.Label>
                                    <Col md={10}>
                                        <Form.Select
                                            name="exchange" 
                                            className="fsz-875rem"
                                            defaultValue={formik.initialValues.exchange &&  formik.initialValues.exchange !== '' ? formik.initialValues.exchange : ''}
                                            // value={formik.values.dsp != "MyDSP" ? 'All' : formik.initialValues.exchange}
                                            disabled={formik.values.dsp !== "MyDSP"}
                                            onChange={
                                                async (e) => {
                                                    await onExchangeChange(e.target.value)
                                                    formik.validateForm();
                                                }}
                                        >
                                            {["General", "GoogleAdx", 'Yandex RU'].map((item: any) => (
                                                <option key={item} value={item}>
                                                    {formik.values.dsp !== "MyDSP"? 'General' : item}
                                                </option>
                                            ))}
                                        </Form.Select> 
                                        {/* <Form.Control.Feedback type="invalid"> {errors.exchange} </Form.Control.Feedback> */}
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="validationFormikInfiniteFIFO">
                                    <Form.Label column md={2}>Infinite FIFO</Form.Label>
                                    <Col md={10}>
                                        <Form.Select
                                            name="infinite_fifo" 
                                            className="fsz-875rem"
                                            defaultValue={formik.initialValues.infinite_fifo}
                                            // value={formik.values.dsp != "MyDSP" ? 'All' : formik.initialValues.exchange}
                                            // disabled={formik.values.dsp === "ESKIMI" || (formik.values.dsp === "MyDSP" && formik.values.exchange === "GoogleAdx")}
                                            onChange={
                                                async (e) => {
                                                    await onInfiniteFifoChange(e)
                                                    formik.validateForm();
                                                }}
                                        >
                                            {["No", "Yes"].map((item: string) => (
                                                <option key={item} value={item}>
                                                    {item}
                                                </option>
                                            ))}
                                        </Form.Select> 
                                        {/* <Form.Control.Feedback type="invalid"> {errors.exchange} </Form.Control.Feedback> */}
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="validationFormikIpV6">
                                    <Form.Label column md={2}>Detect IPv6</Form.Label>
                                    <Col md={10}>
                                        <Form.Select
                                            name="ipv6" 
                                            className="fsz-875rem"
                                            defaultValue={formik.initialValues.ipV6}
                                            
                                            // value={formik.values.dsp != "MyDSP" ? 'All' : formik.initialValues.exchange}
                                            // disabled={formik.values.dsp === "ESKIMI" || (formik.values.dsp === "MyDSP" && formik.values.exchange === "GoogleAdx")}
                                            onChange={
                                                async (e) => {
                                                    await onIpV6Change(e)
                                                    formik.validateForm();
                                                }}
                                        >
                                            
                                            {[{ value: true, name: "Yes" }, { value: false, name: "No"}, ].map((item: any) => (
                                                <option key={item.name} value={item.value}>
                                                    {item.name}
                                                </option>
                                            ))}
                                            
                                            {/* {["No", "Yes"].map((item: string) => (
                                                <option key={item} value={item}>
                                                    {item}
                                                </option>
                                            ))} */}
                                        </Form.Select> 
                                        {/* <Form.Control.Feedback type="invalid"> {errors.exchange} </Form.Control.Feedback> */}
                                    </Col>
                                </Form.Group>
                                
                            </Col>
                            <Col md={6}>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label column md={2}>Type</Form.Label>
                                    <Col md={10}>
                                        <Form.Select
                                            name="type"
                                            defaultValue={formik.initialValues.type}
                                            className="fsz-875rem"
                                            onChange={
                                                async (e) => {
                                                    await onTypeChange(e)
                                                    formik.validateForm();
                                                }}
                                        >
                                            {["Image", "Video"].map((item: string) => (
                                                <option key={item} value={item}>
                                                    {item}
                                                </option>
                                            ))}
                                        </Form.Select> 
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3">
                                    <Form.Label column md={2}>Youtube Video</Form.Label>
                                    <Col md={10}>
                                        <Form.Select
                                            name="YouTubeVideo"
                                            defaultValue={formik.initialValues.YouTubeVideo} 
                                            className="fsz-875rem"
                                            onChange={
                                                async (e) => {
                                                    await onYTVChange(e)
                                                    formik.validateForm();
                                                }}
                                        >
                                            {["No", "Yes"].map((item: string) => (
                                                <option key={item} value={item}>
                                                    {item}
                                                </option>
                                            ))}
                                        </Form.Select> 
                                    </Col>
                                </Form.Group>

                                <Form.Group as={Row} className="mb-3" controlId="validationFormiklandingPage">
                                    <Form.Label column md={2}>Landing Page<span style={{ color: "#dc3545", fontFamily: "Silka", fontSize: 12, }}>*</span></Form.Label>
                                    <Col md={10}>
                                        <Form.Control
                                            type="text"
                                            name="landingPage"
                                            value={formik.values.landingPage}
                                            onChange={formik.handleChange}
                                            isInvalid={!!formik.errors.landingPage} 
                                        />
                                    </Col>
                                </Form.Group>

                                <Form.Group as={Row} className="mb-3" controlId="validationFormiklandingPage">
                                    <Form.Label column md={2}>Yandex ERID
                                        </Form.Label>
                                    <Col md={10}>
                                        <Form.Control
                                            type="text"
                                            name="er_id"
                                            value={formik.values.er_id}
                                            onChange={formik.handleChange}
                                            isInvalid={!!formik.errors.er_id} 
                                            disabled={formik.values.dsp !== 'MyDSP' || (formik.values.dsp === 'MyDSP' && formik.values.exchange !== 'Yandex RU')}
                                        />
                                        {/* <Form.Control.Feedback type="invalid"> {errors.landingPage} </Form.Control.Feedback> */}
                                    </Col>
                                </Form.Group>
                                <Form.Group as={Row} className="mb-3" controlId="validationFormikAddOns">
                                    <Form.Label column md={2}>Add-ons<span style={{ color: "#dc3545", fontFamily: "Silka", fontSize: 12, }}>*</span></Form.Label>
                                    <Col md={10}>
                                        <Form.Select
                                            name="add-ons" 
                                            className="fsz-875rem"
                                            defaultValue={formik.initialValues.addOns}
                                            // value={formik.values.dsp != "MyDSP" ? 'All' : formik.initialValues.exchange}
                                            disabled={formik.values.dsp === "ESKIMI" || (formik.values.dsp === "MyDSP" && formik.values.exchange === "GoogleAdx")}
                                            onChange={
                                                async (e) => {
                                                    await onAddOnsChange(e.target.value)
                                                    formik.validateForm();
                                                }}
                                        >
                                            {["No", "UA", "Timer"].map((item: any) => (
                                                <option key={item} value={item}>
                                                    {formik.values.dsp === "ESKIMI" || (formik.values.dsp === "MyDSP" && formik.values.exchange === "GoogleAdx")? 'No' : item}
                                                </option>
                                            ))}
                                        </Form.Select> 
                                        {/* <Form.Control.Feedback type="invalid"> {errors.exchange} </Form.Control.Feedback> */}
                                    </Col>
                                </Form.Group>
                                {formik.values.infinite_fifo === "Yes" && (
                                <Form.Group as={Row} className="mb-3" controlId="validationFormikInfiniteFIFOID">
                                    <Form.Label column md={2}>Infinite FIFO ID {formik.values.infinite_fifo === "Yes" && (<span style={{ color: "#dc3545", fontFamily: "Silka", fontSize: 12, }}>*</span>)}</Form.Label>
                                    <Col md={10}>
                                        <Form.Control
                                            type="text"
                                            name="infinite_fifo_id"
                                            disabled={formik.values.infinite_fifo === "No"}
                                            value={formik.values.infinite_fifo_id}
                                            onChange={formik.handleChange}
                                            isInvalid={!!formik.errors.infinite_fifo_id}
                                        />
                                    </Col>
                                </Form.Group>)}
                            </Col>
                        </Row>
                        

                        <Row style={{ marginTop: "10px" }}>
                            <Col>
                                <Button style={{ marginLeft: "0", fontWeight: "700" }} type="submit" variant="primary"
                                onClick={() => {
                                    formik.validateForm();
                                    formik.handleSubmit();
                                }}>Save Changes</Button>
                                <Button 
                                    variant="secondary"
                                    onClick={()=>{
                                        setActiveScreen(1);
                                        refreshList();
                                    }}
                                >
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </Row>
        </>
    )

}
export default AddEditTagForm;